import {isNoU, parseContentEditable} from "utils/DBUtils";

const isEmpty = (value) => {
    return (Array.isArray(value) && value.length === 0)
        || (typeof value === 'string' && value.trim() === "");
};

const CharacterLimit = (value, params) => (isNoU(value) ? "" : value).length <= params.limit;
const NotNullOrBlank = (value) => !isNoU(value)
    && !Number.isNaN(value)
    && !isEmpty(value);

const localeCurrencySymbol = {
    "en-US": "$",
    "es-LA": "$",
    "en-GB": "€"
};

export const validationRules = {
    ProperCurrencyValue: (value, params, formProxy) => {
        const resource = formProxy.currentResource;
        const currencyField = params.currencyField;
        const symbol = localeCurrencySymbol[resource.lang];

        if (!isNoU(resource.lang)
            && !isNoU(symbol)
            && value.includes(symbol)
        ) {
            const currencyValue = resource[currencyField];

            // Check if value contains proper value in for currency
            if (!value.includes(currencyValue)) {
                return false;
            }
        }

        return true;
    },
    EmailFormat: (value) => {
        return isNoU(value) || value.trim() === "" || (/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/).test(value);
    },
    PermalinkFormat: (value) => {
        return isNoU(value) || value.trim() === "" || (/^[a-z0-9]+(-[a-z0-9]+)*$/).test(value);
    },
    HexColorFormat: (value) => {
        return isNoU(value) || value.trim() === "" || (/^#[a-fA-F0-9]{6}$/).test(value);
    },
    HyperLinkFormat: (value) => {
        return isNoU(value) || value.trim() === "" || (/^https?:\/\/.+/).test(value);
    },
    NumberFormat: (value) => isNoU(value) || !Number.isNaN(value),
    IntegerFormat: (value) => isNoU(value) || Number.isInteger(parseFloat(value)),
    InclusiveRange: (value, params) => isNoU(value) || (Number(value) >= params.min && Number(value) <= params.max),
    MarkupTextLimit: (value, params) => CharacterLimit(value ? parseContentEditable(value) : '', params),
    CharacterLimit: CharacterLimit,
    NotNullOrBlank: NotNullOrBlank,
    NotNull: (value) => !isNoU(value) && !Number.isNaN(value),
    HTMLHasTextContent: (value) => {
        let node = document.createElement('div');
        node.innerHTML = value;
        let textContent = node.textContent;
        return NotNullOrBlank(textContent);
    },
    StepExists: (value, params, formProxy) => {
      //Check if Step exists in this Break's current platform.
      for (var a = 0; a < formProxy.currentResource.steps.length; a++) {
        if (value == formProxy.currentResource.steps[a].id) {
          return true;
        }
      }

      //Step does not exist in Break's current platform.
      return false;
    },
    NANDGate: (value, params, formProxy) => {
      //NAND Logic gate validation 
      var otherValue = formProxy.currentResource[params.otherField];

      if (value && otherValue)
      {
        return false;
      }

      return true;
    }
};



// WEBPACK FOOTER //
// ./public/components/forms/validationRules.js